import { Component } from "react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack?.slice(0, 200));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center" data-testid="error-boundary">
          <h2 className="font-heading text-xl font-bold mb-2">Etwas ist schiefgelaufen</h2>
          <p className="font-body text-sm text-muted-foreground mb-4">Bitte laden Sie die Seite neu.</p>
          <Button className="font-body" onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}>
            Seite neu laden
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
